import React, { useEffect } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { TextField } from '@/ui/form/controls/TextField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const TimesheetWorkingHours = () => {
  const { t } = useLocalize()
  const { data, setData } = useRaportForm()

  useEffect(() => {
    setData({
      showDetailed: false,
      companyId: '',
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
    })
  }, [])

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <TextField
            label={t('printout.company-identifier')}
            placeholder={t('printout.type-in')}
            name="companyId"
            value={data?.companyId}
            onChange={(e) => setData({ ...data, companyId: e.target.value })}
          />
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
      />
    </div>
  )
}

export default TimesheetWorkingHours
